/*eslint-disable*/
import React, { Component } from "react";
// Redux
import { connect } from "react-redux";
import { getSections } from "../../utils/store/actions/survey.action";
import { show } from "redux-modal";
// reactstrap components
import { Card, Col, Row } from "reactstrap";
// material ui
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
// core components
import { baseUriUsers } from "../../utils/uri";
import { AppBar, Box, Paper, Tab, Tabs, Typography } from "@material-ui/core";
import axios from "axios";

import SurveyDetails from "./SurveyDetails";
import { IParties } from "../../entities/parties/parties.model";

const styles = (theme: Theme) =>
  createStyles({
    paper: {
      backgroundColor: "#F5F6FF",
      margin: "auto",
    },
    searchBar: {
      backgroundColor: "#F5F6FF",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
    searchInput: {
      backgroundColor: "#F5F6FF",
      fontSize: theme.typography.fontSize,
    },
    block: {
      display: "block",
    },
    addUser: {
      marginRight: theme.spacing(1),
    },
    contentWrapper: {
      margin: "40px 16px",
    },
    root: {
      minWidth: 275,
    },
    bullet: {
      display: "inline-block",
      margin: "0 2px",
      transform: "scale(0.8)",
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
  });

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
class Surveys extends Component<any, any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      open: false,
      checked: [],
      expanded: [],
      parties: [],
      modalOpen: false,
      savedModal: false,
      value: 0,
    };
  }

  getParties = async () => {
    const response = await axios.get(
      `${baseUriUsers}/service-user/v1/parties/values`
    );
    return response.data;
  };
  componentWillMount() {
    this.getParties().then((part) => {
      this.setState({ parties: part });
    });
  }
  handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    this.setState({ value: newValue });
  };

  render() {
    const { classes } = this.props;
    const { value } = this.state;
    return (
      <div>
        <Paper className={classes.paper}>
          <Row>
            <Col className="order-xl-2 mb-5 mb-xl-0" xl="12">
              <Card className="card-profile shadow">
                <div className={classes.root}>
                  <AppBar
                    position="static"
                    color="default"
                    style={{ backgroundColor: "transparent", boxShadow: "" }}
                  >
                    <Tabs
                      value={value}
                      onChange={this.handleChange}
                      indicatorColor="primary"
                      textColor="primary"
                      variant="fullWidth"
                      aria-label="full width tabs example"
                    >
                      {this.state.parties.map((party: any, i: any) => (
                        <Tab
                          label={party.toLowerCase().replace("_", " ")}
                          {...a11yProps(i)}
                          disabled={!IParties.includes(party)}
                        />
                      ))}
                    </Tabs>
                  </AppBar>
                  {this.state.parties.map((party: any, i: any) => (
                    <TabPanel value={value} index={i}>
                      <SurveyDetails
                        party={party.toLowerCase().replace("_", "-")}
                      />
                    </TabPanel>
                  ))}
                </div>
              </Card>
            </Col>
          </Row>
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = (state: { Surveys: SurveyState }) => ({
  Surveys: state.Surveys,
});

const mapDispatchToProps = {
  getSections,
  show,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Surveys));
